"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NumberingStyleExporter = void 0;
var tslib_1 = require("tslib");
var style_base_1 = require("./style-base");
var NumberingStyleExporter = (function (_super) {
    tslib_1.__extends(NumberingStyleExporter, _super);
    function NumberingStyleExporter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NumberingStyleExporter.prototype.getStyleId = function (styleIndex) {
        return 'N' + styleIndex.toString();
    };
    NumberingStyleExporter.prototype.getStyleIndexByName = function (name) {
        return this.data.model.stylesManager.characterStyleNameToIndex[name];
    };
    NumberingStyleExporter.prototype.getType = function () { return ''; };
    NumberingStyleExporter.prototype.exportCore = function (_style) {
    };
    return NumberingStyleExporter;
}(style_base_1.StyleBaseExporter));
exports.NumberingStyleExporter = NumberingStyleExporter;
